import React from 'react';

import { useIntl } from 'react-intl';

import { useAuthContext } from 'state/auth';

import { LoggedOutEmptyStateImage } from './images';
import {
  EmptyStateWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const LoggedOutEmptyState = () => {
  const { formatMessage } = useIntl();
  const { openSignInModal } = useAuthContext();

  const onPress = () => {
    openSignInModal();
  };

  return (
    <EmptyStateWrapper>
      <ImageWrapper>
        <LoggedOutEmptyStateImage />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: 'unauthenticatedFavoritesHeader' })}</HeaderText>
      <SubText>{formatMessage({ id: 'unauthenticatedFavoritesSubtext' })}</SubText>
      <StyledActionButtonLink onPress={onPress}>
        {formatMessage({ id: 'logIn' })}
      </StyledActionButtonLink>
    </EmptyStateWrapper>
  );
};

export default LoggedOutEmptyState;
